export const THIRTY_SIX = 36;
export const FORTY_EIGHT = 48;
export const SIXTY = 60;
export const SEVENTY_TWO = 72;

export const THIRTY_SIX_MO = '36 mo';
export const FORTY_EIGHT_MO = '48 mo';
export const SIXTY_MO = '60 mo';
export const SEVENTY_TWO_MO = '72 mo';

export const TEN = 10;
export const FIFTEEN = 15;
export const TWENTY = 20;
export const TWENTY_FIVE = 25;
export const THIRTY = 30;

export const TEN_YRS = '10 yrs';
export const FIFTEEN_YRS = '15 yrs';
export const TWENTY_YRS = '20 yrs';
export const TWENTY_FIVE_YRS = '25 yrs';
export const THIRTY_YRS = '30 yrs';

export const DEFAULT_LOAN_TERM = {
  60: 60,
};

export const GET_LOAN_TERMS_DISPLAY_INFO = (selectedLoanTerms) => ({
  [THIRTY_SIX]: {
    text: THIRTY_SIX_MO,
    selected: !!selectedLoanTerms[THIRTY_SIX],
  },
  [FORTY_EIGHT]: {
    text: FORTY_EIGHT_MO,
    selected: !!selectedLoanTerms[FORTY_EIGHT_MO],
  },
  [SIXTY]: {
    text: SIXTY_MO,
    selected: !!selectedLoanTerms[SIXTY_MO],
  },
  [SEVENTY_TWO]: {
    text: SEVENTY_TWO_MO,
    selected: !!selectedLoanTerms[SEVENTY_TWO],
  },
});

export const MORTGAGE_LOAN_TERMS = {
  [TEN]: {
    text: TEN_YRS,
    getSelected: (selectedLoanTerms) => !!selectedLoanTerms[TEN],
  },
  [FIFTEEN]: {
    text: FIFTEEN_YRS,
    getSelected: (selectedLoanTerms) => !!selectedLoanTerms[FIFTEEN],
  },
  [TWENTY]: {
    text: TWENTY_YRS,
    getSelected: (selectedLoanTerms) => !!selectedLoanTerms[TWENTY],
  },
  // [TWENTY_FIVE]: {
  //   text: TWENTY_FIVE_YRS,
  //   getSelected: (selectedLoanTerms) => !!selectedLoanTerms[TWENTY_FIVE],
  // },
  [THIRTY]: {
    text: THIRTY_YRS,
    getSelected: (selectedLoanTerms) => !!selectedLoanTerms[THIRTY],
  },
};

export const LOAN_TERMS = {
  [THIRTY_SIX]: {
    text: THIRTY_SIX_MO,
    getSelected: (selectedLoanTerms) => !!selectedLoanTerms[THIRTY_SIX],
  },
  [FORTY_EIGHT]: {
    text: FORTY_EIGHT_MO,
    getSelected: (selectedLoanTerms) => !!selectedLoanTerms[FORTY_EIGHT_MO],
  },
  [SIXTY]: {
    text: SIXTY_MO,
    getSelected: (selectedLoanTerms) => !!selectedLoanTerms[SIXTY_MO],
  },
  [SEVENTY_TWO]: {
    text: SEVENTY_TWO_MO,
    getSelected: (selectedLoanTerms) => !!selectedLoanTerms[SEVENTY_TWO],
  },
};

export const AUTO_OR_MORTGAGE_LOAN_TERMS = {
  Auto: LOAN_TERMS,
  Home: MORTGAGE_LOAN_TERMS,
};

export const LOAN_TERM_HEADER = 'Loan Term(s)';
export const CREDIT_TIER = 'Credit Tier';

export const REBUILDING = 'Rebuilding';
export const FAIR = 'Fair';
export const GOOD = 'Good';
export const EXCELLENT = 'Excellent';

export const CREDIT_SCORE_OBJ = {
  [REBUILDING]: 640,
  [FAIR]: 675,
  [GOOD]: 725,
  [EXCELLENT]: 800,
};

export const REBUILDING_SCORE = '<640';
export const FAIR_SCORE = '641-699';
export const GOOD_SCORE = '700-749';
export const EXCELLENT_SCORE = '750-850';

export const getIfCreditTierSelected = ({ credit_tier_score, selected_credit_tier } = {}) => {
  return credit_tier_score === selected_credit_tier;
};

export const CREDIT_TIER_FIELD_DISPLAY = {
  [REBUILDING]: {
    text: REBUILDING,
    score: REBUILDING_SCORE,
    selected: getIfCreditTierSelected,
  },
  [FAIR]: {
    text: FAIR,
    score: FAIR_SCORE,
    selected: getIfCreditTierSelected,
  },
  [GOOD]: {
    text: GOOD,
    score: GOOD_SCORE,
    selected: getIfCreditTierSelected,
  },
  [EXCELLENT]: {
    text: EXCELLENT,
    score: EXCELLENT_SCORE,
    selected: getIfCreditTierSelected,
  },
};

export const SELECTED_TAB_STYLE = {
  backgroundColor: 'black',
  color: 'white',
  '&:hover': { backgroundColor: 'black', color: 'white' },
};

export const DEFAULT_TAB_STYLE = {
  '&:hover': { backgroundColor: 'white', color: 'black' },
  m: 1,
  ml: 0,
  color: 'black',
  textTransform: 'initial',
  backgroundColor: 'white',
  width: '22.5%',
  minWidth: 50,
};

export const FORM_CONTROL_FULL_WIDTH_INPUT_STYLE = {
  m: 0,
  minWidth: 120,
  mr: 1,
  width: '98%',
  maxWidth: 420,
};

export const ESTIMATE_VALUE = 'Estimate Value';
